import React, { Children } from "react";
import { Flex, Card, Input, Divider, Tabs } from "antd";
import ShopCard from './my-card';

export default ({ list = [] }) => {

    return (
        <Flex justify="start" wrap gap={15} align="center">
            {
                list.map((item, index) => {

                    return (
                        
                        <ShopCard content={item} key={index} />
                        
                    )
                })
            }
    </Flex>
   );
};
